module.exports = __webpack_public_path__ + "static/img/alipay.3edf4adb.png";